import React from 'react';
import PropTypes from 'prop-types';
import { prop } from 'ramda';

import { ButtonsCollection, ModalWindow } from '../../../../../ui-kit';
import './style.sass';

const DeleteCategory = ({
  isOpen,
  isPending,
  onCloseModal,
  category,
  onDelete,
  t,
}) => (
  <ModalWindow
    isOpen={isOpen}
    onClose={onCloseModal}
    className="delete-category__modal"
    modalName="Delete category"
    title="Delete category"
  >
    <>
      <div className="row  text-align--left">
        <span className="delete-category__title title-md">
          {t('Are you sure you want to delete')}
          <b className="delete-category__name">{prop('title', category)}</b>
          {`${t('category')}?`}
        </span>
      </div>
      <div className="delete-category__button-row">
        <ButtonsCollection.ButtonBrill
          type="button"
          onClick={onDelete}
          pending={isPending}
          className="button--md delete-category__button-control button-brill--fill"
        >
          {t('Delete')}
        </ButtonsCollection.ButtonBrill>
        <button
          type="button"
          className="button--cancel"
          onClick={onCloseModal}
        >
          {t('Cancel')}
        </button>
      </div>
    </>
  </ModalWindow>
);

DeleteCategory.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  category: PropTypes.instanceOf(Object).isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default DeleteCategory;
